import React from 'react';
import styled from '@emotion/styled';
import Icon from '~ComponentsImproved/Icon';
import ArrowIcon from '~Assets/icons/navigate-right.svg';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  display: flex;
  flex-flow: nowrap;
  overflow: auto;
  width: calc(100% - 200px);
  left: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  background: rgba(17, 14, 22, 0.8);
  height: 64px;
  box-sizing: border-box;
  padding: 4px 16px;
  left: 200px;
  overflow: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin: 0 8px;
  }
`;

const Button = styled.button<{ current: boolean }>`
  border-radius: 4px;
  border: 2px solid;
  border-color: ${({ current }) =>
    current ? 'var(--colorBlueGray600)' : 'var(--colorBlueGray400)'};
  background-color: transparent;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: var(--letterSpacing);
  color: ${({ current }) => (current ? 'var(--colorBlueGray600)' : 'var(--colorWhite)')};
  height: 40px;
  padding: 4px 16px;
  box-sizing: border-box;
  max-width: 300px;
  pointer-events: ${({ current }) => (current ? 'none' : 'auto')};

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
`;

export interface Props {
  breadcrumbs: { id: string; name: string }[];
  handleClick: (index: number) => void;
}

const Breadcrumbs = ({ breadcrumbs, handleClick }: Props) => {
  const { i18n } = useI18n();
  return (
    <Wrapper>
      {breadcrumbs.map((crumb, i) => (
        <ButtonWrapper key={crumb.id}>
          <Button current={breadcrumbs.length === i + 1} onTouchStart={() => handleClick(i)}>
            <span>{i18n(crumb.name) ?? crumb.name}</span>
          </Button>
          {breadcrumbs.length > i + 1 && <Icon src={ArrowIcon} />}
        </ButtonWrapper>
      ))}
    </Wrapper>
  );
};

export default Breadcrumbs;
